export const REGEX = {
  stringValidate: /^[A-Za-z\s]+$/,
  emailValidate: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
  specificEmailValidate: /^[a-zA-Z0-9_.+-]+@((?!yopmail)[a-zA-Z0-9-]{3,}\.[a-zA-Z]{2,}|gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|icloud\.com|live\.com|aol\.com)$/,
  passwordValidate: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#.^])[A-Za-z\d@$!%*?&#.^]{8,}$/,
};

export const URLs = {
  xURL: "https://twitter.com/GreatNonprofits",
  facebook: "https://www.facebook.com/greatnonprofits",
  instagram: "https://www.instagram.com/greatnonprofits/",
  linkedin: "https://www.linkedin.com/company/greatnonprofits",
  mail: "nonprofit@gmail.com",
  phone: "+1 (525) 854-7297"
}



